import { render, staticRenderFns } from "./shape.md?vue&type=template&id=42977a39&"
import script from "./shape.md?vue&type=script&lang=js&"
export * from "./shape.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42977a39')) {
      api.createRecord('42977a39', component.options)
    } else {
      api.reload('42977a39', component.options)
    }
    module.hot.accept("./shape.md?vue&type=template&id=42977a39&", function () {
      api.rerender('42977a39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/Wave/shape.md"
export default component.exports